import { Routes } from '@angular/router';

export const FIELDMETHODOLOGY_ROUTES: Routes = [
  {
    path: 'channels/field-methodologies/view-edit/:fieldMethodologyId',
    loadComponent: () =>
      import('./field-methodology-view-edit/field-methodology-view-edit.component').then(
        (com) => com.FieldMethodologyViewEditComponent
      ),
    title: 'View/Edit Field Methodology',
  },
  {
    path: 'channels/field-methodologies/add',
    loadComponent: () =>
      import('./field-methodology-add/field-methodology-add.component').then(
        (com) => com.FieldMethodologyAddComponent
      ),
    title: 'Add Field Methodology',
  },
];
